document.addEventListener("DOMContentLoaded", async () => {

const cards = document.querySelectorAll(".product-card");

if(cards.length === 0) return;

const productsData = [];

cards.forEach(card => {

const handle = card.dataset.handle;
const countEl = card.querySelector(".download-count");

if(!handle || !countEl) return;

productsData.push({
handle: handle,
element: card,
countEl: countEl
});

});

productsData.forEach(item => {

const downloads = Math.floor(Math.random() * 50) + 1;

item.countEl.innerText = downloads;

});

});